(() => {
  'use strict';

  // Both notices are limited to one display per tab/session, across page navigation.
  // The second notice is due 35 seconds after the FIRST real storefront scroll.
  const REMINDER_DELAY_MS = 35000;
  const STORAGE_PREFIX = 'getnails-account-reminder-2026-10-17-v1:';
  const root = document.querySelector('[data-gn-account-reminder]');
  if (!root || (window.Shopify && window.Shopify.designMode)) return;

  const panel = root.querySelector('.gn-account-reminder__panel');
  const closeButton = root.querySelector('.gn-account-reminder__close');
  if (!panel || !closeButton) return;

  const memoryStorage = Object.create(null);
  const key = (item) => STORAGE_PREFIX + item;
  const read = (item) => {
    try {
      return window.sessionStorage.getItem(key(item)) || memoryStorage[item] || null;
    } catch (error) {
      return memoryStorage[item] || null;
    }
  };
  const write = (item, value) => {
    memoryStorage[item] = String(value);
    try {
      window.sessionStorage.setItem(key(item), String(value));
    } catch (error) {
      // Still show the reminders if storage is disabled.
    }
  };

  let firstScrollAt = Number(read('firstScrollAt')) || 0;
  let secondShown = read('secondShown') === '1';
  let isOpen = false;
  let previousOverflow = '';
  let previousFocus = null;
  let secondTimer = null;
  let previousScrollPosition = window.scrollY || window.pageYOffset || 0;

  function show(which) {
    if (isOpen || document.visibilityState === 'hidden') return false;
    if (which === 'first' && read('firstShown') === '1') return false;
    if (which === 'second' && secondShown) return false;

    if (which === 'first') write('firstShown', '1');
    if (which === 'second') {
      secondShown = true;
      write('secondShown', '1');
    }

    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    closeButton.focus({ preventScroll: true });
    return true;
  }

  function close() {
    if (!isOpen) return;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    isOpen = false;

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
    previousScrollPosition = window.scrollY || window.pageYOffset || 0;
    scheduleSecond();
  }

  function scheduleSecond() {
    if (!firstScrollAt || secondShown) return;
    if (secondTimer !== null) window.clearTimeout(secondTimer);

    const msRemaining = firstScrollAt + REMINDER_DELAY_MS - Date.now();
    if (msRemaining > 0) {
      secondTimer = window.setTimeout(scheduleSecond, msRemaining);
      return;
    }

    secondTimer = null;
    if (!isOpen) show('second'); // Never stack the two dialogs.
  }

  function onScroll() {
    if (firstScrollAt || secondShown || isOpen) return;
    const newPosition = window.scrollY || window.pageYOffset || 0;
    if (Math.abs(newPosition - previousScrollPosition) < 8) return;

    firstScrollAt = Date.now();
    write('firstScrollAt', firstScrollAt);
    window.removeEventListener('scroll', onScroll);
    scheduleSecond();
  }

  root.addEventListener('click', (event) => {
    if (event.target.closest('[data-gn-account-close]')) close();
  });

  root.addEventListener('keydown', (event) => {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleSecond();
  });
  window.addEventListener('pageshow', scheduleSecond);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  function start() {
    if (read('firstShown') !== '1') show('first');
    if (!firstScrollAt && !secondShown) {
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      scheduleSecond();
    }
  }
})();
